var map = {
	"./icon-activity.svg": 854,
	"./icon-bitbucket.svg": 855,
	"./icon-broadcast.svg": 856,
	"./icon-checkmark-sm.svg": 857,
	"./icon-chevron-down.svg": 858,
	"./icon-chevron-left.svg": 859,
	"./icon-chevron-right.svg": 860,
	"./icon-circle-add.svg": 861,
	"./icon-circle-check.svg": 862,
	"./icon-circle-close.svg": 863,
	"./icon-circle-exclamation.svg": 864,
	"./icon-circle-info.svg": 865,
	"./icon-circle-question.svg": 866,
	"./icon-circle-subtract.svg": 867,
	"./icon-clipboard.svg": 868,
	"./icon-close-lg.svg": 869,
	"./icon-collapse.svg": 870,
	"./icon-copy.svg": 871,
	"./icon-docs.svg": 872,
	"./icon-download.svg": 873,
	"./icon-github.svg": 874,
	"./icon-history.svg": 875,
	"./icon-input.svg": 876,
	"./icon-laptop.svg": 877,
	"./icon-link.svg": 878,
	"./icon-location.svg": 879,
	"./icon-lock.svg": 880,
	"./icon-mail.svg": 881,
	"./icon-print.svg": 882,
	"./icon-projects.svg": 883,
	"./icon-refresh.svg": 884,
	"./icon-return-key.svg": 885,
	"./icon-search.svg": 886,
	"./icon-sentry.svg": 887,
	"./icon-settings.svg": 888,
	"./icon-stack.svg": 889,
	"./icon-star.svg": 890,
	"./icon-stats.svg": 891,
	"./icon-support.svg": 892,
	"./icon-trash.svg": 893,
	"./icon-user.svg": 894,
	"./icon-warning-sm.svg": 895
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 853;


//////////////////
// WEBPACK FOOTER
// ./app/icons ^\.\/.*\.svg$
// module id = 853
// module chunks = 74